import { useRef } from "react";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";
import { Modal } from "../../../common/components/Modal";
import { GameDepositDialog } from "../gameDepositDialog/GameDepositDialog";

export const GamePlayDialog = ({
  toggleButton,
  companyCode,
  gameType,
  companyOffset,
  scrollPosition,
  searchName,
  isDemo = false,
}) => {
  const intl = useIntl();
  const dismissBtnRef = useRef();
  const navigate = useNavigate();

  const handleDeposit = () => {
    document.getElementById("gameDepositModalToggleBtn").click();
    dismissBtnRef.current.click();
  };
  const handleChangePosition = () => {
    dismissBtnRef.current.click();
    toggleButton();
  };

  const handleGoBack = () => {
    dismissBtnRef.current.click();
    if (isDemo) {
      const params = new URLSearchParams(window.location.search);

      navigate(`/`, {
        state: {
          companyCode,
          gameType,
          scrollPosition,
          isShowMore: params.get("isShowMore"),
        },
      });
    } else
      navigate(`/${gameType}/${companyCode}`, {
        state: { companyOffset, searchName, scrollPosition },
      });
  };

  return (
    <div>
      <Modal
        modalId="gamePlayModal"
        title={intl.formatMessage({ id: "option" })}
        dismissBtnRef={dismissBtnRef}
        modalSize="modal-lg"
      >
        <div className="p-3">
          {!isDemo && (
            <div
              onClick={handleDeposit}
              style={{
                width: "100%",
                height: "50px",
                display: "flex",
                cursor: "pointer",
                alignItems: "center",
                borderBottom: "1px solid #262626",
              }}
            >
              {intl.formatMessage({ id: "deposit" })}
            </div>
          )}

          <div
            onClick={handleChangePosition}
            style={{
              width: "100%",
              height: "50px",
              display: "flex",
              cursor: "pointer",
              alignItems: "center",
              borderBottom: "1px solid #262626",
            }}
          >
            {intl.formatMessage({ id: "changePosition" })}
          </div>

          <div
            onClick={handleGoBack}
            style={{
              width: "100%",
              height: "50px",
              display: "flex",
              cursor: "pointer",
              alignItems: "center",
            }}
          >
            {intl.formatMessage({ id: "backPage" })}
          </div>
        </div>
      </Modal>

      {!isDemo && <GameDepositDialog companyCode={companyCode} />}
    </div>
  );
};
